import { Route } from "react-router-dom";
import { RenderableView } from "./components/RenderableView";

const convertPathsToViews = (paths = [], additionalProps = {}) =>
  paths.map((pathInformation, index) => {
    return (
      <Route
        key={`route${pathInformation.path}#${index}`}
        path={pathInformation.path}
        element={<RenderableView {...additionalProps} {...pathInformation} />}
      />
    );
  });

  const createSearchPageTitle = ({ searchParams = {}, query = "", loading = false, additionalLabel }) => {
  const q = (searchParams?.get ? searchParams?.get("q") : query) ?? ""
  let searchQuery = q
  
  try {
    const parsed = searchQuery ? decodeURIComponent(searchQuery ?? "") : ''
    searchQuery = parsed    
  } catch (error) {
    console.error(error)
  }
  if(searchQuery) {
    searchQuery = searchQuery.replaceAll("#", "")
  }
  let _label = ''
  if(loading) {
    _label = `Searching`
    if(additionalLabel) {
        _label += (" " + additionalLabel + ' for')
    }
    if(searchQuery) {
      _label += `: ${searchQuery}`
    }
    return _label
  }
  _label = `Search` 
  if(additionalLabel) {
    _label += ` ${additionalLabel}`
  } 
  if(searchQuery) {
    _label += ` Results: ${searchQuery}`
  }

  return _label
}

export { convertPathsToViews, createSearchPageTitle };
